import { render, staticRenderFns } from "./CinemaDaily.vue?vue&type=template&id=9990d174&scoped=true&"
import script from "./CinemaDaily.vue?vue&type=script&lang=js&"
export * from "./CinemaDaily.vue?vue&type=script&lang=js&"
import style0 from "./CinemaDaily.vue?vue&type=style&index=0&id=9990d174&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9990d174",
  null
  
)

export default component.exports